angular.module('SpidApp')

.constant('RestrictionAdapterConfig', {
  name : 'Restriction',
  fields : [
    {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'code',
    	distant : 'code'
    }, {
    	local   : 'label',
    	distant : 'label'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'deleted_at',
    	distant : 'deleted_at'
    }
  ]
})
